namespace TabAurous.Retail {
    export namespace POSReturnLaborService {
        export const baseUrl = 'Retail/POSReturnLabor';

        export declare function Create(request: Serenity.SaveRequest<POSReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSReturnLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<POSReturnLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSReturnLabor/Create",
            Update = "Retail/POSReturnLabor/Update",
            Delete = "Retail/POSReturnLabor/Delete",
            Retrieve = "Retail/POSReturnLabor/Retrieve",
            List = "Retail/POSReturnLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>POSReturnLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
